/** @file Auto-rig panel host: one session per open project (closed on unmount), wired to REST and stores. */
import type { IDockviewPanelProps } from 'dockview-react';
import { useEffect, useMemo } from 'react';
import { useStore } from 'zustand';
import { api } from '../../api/api';
import { whenConfirmed } from '../../api/sync/whenConfirmed';
import { ImportButtons } from '../../import/ImportButtons';
import { useT } from '../../shell/i18n/useT';
import { docStore } from '../../stores/docStore';
import { AutorigPanelBody } from './AutorigPanelBody';
import { autorigPorts } from './autorigPorts';
import { createAutorigSession } from './createAutorigSession';

/** Closing the panel (or leaving the project) clears its ghost and drops answers still in flight. */
export function AutorigPanel(_props: IDockviewPanelProps) {
  const t = useT();
  const projectId = useStore(docStore, (s) => s.projectId);
  const session = useMemo(() => createAutorigSession(autorigPorts(api, projectId ?? '')), [projectId]);
  useEffect(() => () => { session.close(); }, [session]);
  if (projectId === null) return null;
  return <AutorigPanelBody t={t} session={session} imports={<ImportButtons t={t} projectId={projectId} confirmed={whenConfirmed} />} />;
}
